import {
	GetLoanDefinitionForDealRes,
	ProgrammeSecurityAllocationTct,
	SummaryMipNameTct,
	UpdateProgrammeSecurityAllocationDto,
} from '@dealstack/shared/lib/generated';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer.ts';
import { formatUnicorn } from '@dealstack/shared/lib/format/formatUnicorn.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1.ts';

export const getSecurityAllocations = async (args: {
	securityId: string;
}): Promise<ProgrammeSecurityAllocationTct[]> => {
	const endpoint = formatUnicorn(
		API_PATHS.PROGRAMME_SECURITY_ALLOCATIONS_SECURITY_SECURITYID_GET,
		{
			securityId: args.securityId,
		}
	);
	return makeRequest<ApiV1.Response<ProgrammeSecurityAllocationTct[]>>({
		endpoint,
		method: HTTP_METHOD.GET,
	}).then((response) => response.payload ?? []);
};

export const getAllocationsAvailableMips = async (args: {
	dealId: string;
	securityId: string;
	includeMipId?: string;
}): Promise<SummaryMipNameTct[]> => {
	const endpoint = formatUnicorn(
		API_PATHS.PROGRAMME_SECURITY_ALLOCATIONS_SECURITY_SECURITYID_MIP_LIST_GET,
		{
			securityId: args.securityId,
		}
	);
	return makeRequest<ApiV1.Response<SummaryMipNameTct[]>>({
		endpoint,
		method: HTTP_METHOD.GET,
		queryString: {
			dealId: args.dealId,
			includeMipId: args.includeMipId,
		},
	}).then((response) => response.payload ?? []);
};

export const createSecurityAllocation = async (
	body: UpdateProgrammeSecurityAllocationDto
): Promise<ProgrammeSecurityAllocationTct | null> => {
	return makeRequest<ApiV1.Response<ProgrammeSecurityAllocationTct | null>>({
		endpoint: API_PATHS.PROGRAMME_SECURITY_ALLOCATIONS_POST,
		method: HTTP_METHOD.POST,
		body: JSON.stringify(body),
	}).then((response) => response.payload || null);
};

export const updateSecurityAllocation = async ({
	allocationId,
	body,
}: {
	allocationId: string;
	body: UpdateProgrammeSecurityAllocationDto;
}): Promise<ProgrammeSecurityAllocationTct | null> => {
	const endpoint = formatUnicorn(API_PATHS.PROGRAMME_SECURITY_ALLOCATIONS_ALLOCATIONID_PUT, {
		allocationId,
	});
	return makeRequest<ApiV1.Response<ProgrammeSecurityAllocationTct>>({
		endpoint,
		method: HTTP_METHOD.PUT,
		body: JSON.stringify(body),
	}).then((response) => response.payload ?? null);
};

export const deleteAllocationById = async (allocationId: string): Promise<void> => {
	const endpoint = formatUnicorn(API_PATHS.PROGRAMME_SECURITY_ALLOCATIONS_ALLOCATIONID_DELETE, {
		allocationId,
	});
	return makeRequest<void>({
		endpoint,
		method: HTTP_METHOD.DELETE,
	});
};

export const getDealLoanDefinitions = async (): Promise<GetLoanDefinitionForDealRes[]> => {
	return makeRequest<ApiV1.Response<GetLoanDefinitionForDealRes[]>>({
		endpoint: API_PATHS.SECURITY_LOAN_DEFINITIONS_GET,
		method: HTTP_METHOD.GET,
	}).then((response) => response.payload ?? []);
};
